import { render, staticRenderFns } from "./LogInPaper.vue?vue&type=template&id=50143d1e&scoped=true&"
import script from "./LogInPaper.vue?vue&type=script&lang=js&"
export * from "./LogInPaper.vue?vue&type=script&lang=js&"
import style0 from "./LogInPaper.vue?vue&type=style&index=0&id=50143d1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50143d1e",
  null
  
)

export default component.exports